/** @format */

import React, { useState, useRef } from 'react';
import { PageContainer, FilterPod, TableComponents } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useStyles } from './Style';
import { Box, Grid } from '@mui/material';
import Services from '../../services/ServicesCustomersWithdraws';
import { columns, generateData } from './Columns';
import InitFilters from '../../constants/InitFiltering';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

const CusomterWithdraws = () => {
  // -- STATES --//
  const tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const currencyText = useCurrencyUnit();
  const actionsList = getDynamicObjectAction(['permitsWithdrawRulesBtn']);
  const getAccounts = async (val) => {
    if (val?.length >= 2) {
      try {
        const q = {
          size: 10,
          offset: 0,
        };
        const body = {
          filterVOS: [
            {
              id: 2150,
              value: val,
            },
          ],
          orderByElementVOS: [],
          parentParams: [],
        };
        const result = await Services.getClients(body, q);
        const data = result.result?.rows ?? [];
        let list = [];
        list = data.map((val) => ({
          name: val?.cols?.[4],
          id: val?.cols?.[2],
          label: `${val?.cols?.[4]} (شناسه: ${val?.cols?.[2]})`,
          value: val?.cols?.[2],
        }));
        return list;
      } catch (e) {
        console.log('e :', e);
        return [];
      }
    }
  };

  const [filters, setFilters] = useState(InitFilters(getAccounts));

  // --HOOKS--//
  const classes = useStyles();

  // --API REQUESTS--//
  const getList = async (query) => {
    try {
      setLoading(true);

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      setFilterParams({ params });

      const res = await Services.getWithdrawRules(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const hint =
    'در این قسمت می‌توانید لیست مجوزهایی که مشتریانتان به شما برای برداشت از حسابشان داده‌اند را مشاهده کنید.';

  var x = 10;
  var y = 20;
  var z = x + y;

  return (
    <PageContainer
      title="لیست مجوزهای برداشت"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.WITHDRAWRULES_CUSTOMERS_RULES}
      className={classes.root}
    >
      {(actionsList['permitsWithdrawRulesBtn'] && currencyText) && (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          {currencyText && (
            <TableComponents
              data={getList}
              columns={columns(currencyText)}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getList(ps);
              }}
            />
          )}
        </>
      )}
    </PageContainer>
  );
};

export default CusomterWithdraws;
